import { EntityDto } from "../dto";
import { Api } from "../helpers";

export class EntityApi {
  static async getAll(): Promise<EntityDto[] | undefined> {
    const response = await Api.get<EntityDto[]>("/api/v1/core/entities");

    return response?.data;
  }

  static async create(data: EntityDto): Promise<EntityDto | undefined> {
    const response = await Api.post<EntityDto>("/api/v1/core/entities", data);

    return response?.data;
  }

  static async update(data: EntityDto): Promise<EntityDto | undefined> {
    const response = await Api.patch<EntityDto>(
      `/api/v1/core/entities/${data.id}`,
      data,
    );

    return response?.data;
  }

  static async delete(id: number): Promise<EntityDto | undefined> {
    const response = await Api.delete<EntityDto>(`/api/v1/core/entities/${id}`);

    return response?.data;
  }
}
